var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-view"},[_c('failure-question',{attrs:{"question":_vm.question,"question-number":_vm.questionNumber,"parent-question":null},on:{"answer":_vm.onAnswer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }